import React from "react";
import { Table } from "antd";
import { IconDelete, IconEdit } from "../../../../common/ui/icons";
import TablePageSize from "./TablePageSize";

const FoodProductsTable = ({
  data,
  onChange,
  loading,
  editFoodProduct,
  changePageSize,
  deleteFoodProductFromList
}) => {
  const columns = [
    {
      title: "Наименование",
      dataIndex: "food_product_name",
      key: "food_product_name",
      sorter: true,
      render: food_product_name => {
        return food_product_name;
      }
    },
    {
      title: "Вес/объем",
      dataIndex: "food_product_volume",
      key: "food_product_volume",
      render: food_product_volume => {
        return food_product_volume;
      }
    },
    {
      dataIndex: "food_product_id",
      render: food_product_id => {
        return (
          <div style={{ minWidth: "64px", textAlign: "right" }}>
            <IconEdit
              style={{ color: "#00A8FF", marginRight: 16 }}
              onClick={() => {
                editFoodProduct(food_product_id);
              }}
            />
            <IconDelete
              style={{ color: "#F5222D" }}
              onClick={() => {
                deleteFoodProductFromList(food_product_id);
              }}
            />
          </div>
        );
      }
    }
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data.data}
        className={"food-products-table"}
        rowKey={"food_product_id"}
        onChange={onChange}
        loading={loading}
        pagination={{
          pageSize: data ? data.per_page : 0,
          total: data ? data.total : 0,
          current: data ? data.current_page : 0
        }}
      />
      {data && data.data && data.data.length > 0 && (
        <TablePageSize
          changePageSize={changePageSize}
          pages={data ? data.per_page : 0}
        />
      )}
    </>
  );
};

export default FoodProductsTable;
